import { Apis } from '@/appSettings'
import { useUrl } from '.'

import type { Statistics, StatisticsQuery } from 'BrokerTsLib/src/dtos'
import apiClient from 'BrokerTsLib/src/Utils/apiClient'
import { useMutation } from 'react-query'

export const useGetStatistics = () => {
  const url = useUrl(Apis.statistics)

  return useMutation({
    mutationFn: (search: StatisticsQuery) =>
      apiClient.post<Statistics>(`${url}/GetStatistics`, search).then(res => res.data)
  })
}